module.exports = __webpack_public_path__ + "static/industries-manufacturing-image-f55ea959322ea4b06e98e32a56d668ae.jpg";